import styled from '@emotion/styled'

export const SessionInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ButtonContainer = styled.div`
  margin-bottom: 5px;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 5px 10px;
  }
`

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  @media (max-width: 380px) {
    min-width: 100px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  margin-right: 10px;
  padding: 15px 0;
  width: 100%;
  @media (max-width: 768px) {
    padding: 5px 0;
  }
`

export const Error = styled.div`
  color: red;
  margin-bottom: 8px;
`
